import { useTranslation } from '@hopin-team/provider-translation';
import { Card as BaseCard } from '@hopin-team/ui-card';
import { Flex } from '@hopin-team/ui-flex';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { Logo } from '@hopin-team/ui-logo';
import { Text } from '@hopin-team/ui-text';
import { createReactBindings, ReactiveMap } from '@slicesjs/react-core';
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { Analytics } from './components/Analytics';
import { SliceMount } from './slice-mount';
import { ThemeProvider } from '@hopin-team/provider-theme';

const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
    margin: 0;
    background-color: ${({ theme }) =>
      getFromTheme('COLOR.THEME.PRIMARY', theme as any)};
  }

  // this div is the slice root container so can't style using styled.
  body > div:first-child {
    height: 100vh;
  }
`;

const Heading = styled(Text).attrs({
  color: 'grey-white',
  element: 'h1',
  pattern: 'headingOne',
  weight: 'regular',
})`
  display: flex;
  justify-content: center;
  /*
   * flex-end aligns the logo and text bottoms which
   * keeps them properly inline with each other:
   */
  align-items: flex-end;
  font-size: 1.6875rem;
  font-weight: ${({ theme }) =>
    getFromTheme('TYPOGRAPHY.TEXT_FONT_WEIGHT.MEDIUM', theme)};
  line-height: 2rem;
  margin-bottom: 0.75rem;
  @media (min-width: 500px) {
    margin-bottom: 1.5rem;
  }
  ${Logo} svg {
    color: white;
  }
`;

const Card = styled(BaseCard)`
  width: 100%;
  max-width: 46rem;
  min-height: 19rem;
  // subtract Heading height and Heading margin:
  max-height: calc(100% - 2rem - 0.75rem);
  @media (min-width: 500px) {
    max-height: calc(100% - 2rem - 1.5rem);
  }
`;

const Wrapper = styled(Flex)`
  /* This works in conjunction with the Card's min-height
   * so that the page only scrolls when the Card shouldn't
   * shrink any more:
   */
  overflow: auto;
`;

const { SlicesProvider } = createReactBindings();

export const Precall = () => {
  const { t } = useTranslation();
  const reactiveMap = new ReactiveMap();

  return (
    <ThemeProvider rcStyles>
      <GlobalStyle />
      <Wrapper p={3} alignItems="center" flexDirection="column">
        <Analytics />
        <Heading data-testid="precall-page-heading">
          <Logo
            mr={1}
            scale={3.25}
            title="RingCentral"
            type="ringcentral-inverse"
            data-testid="precall-page-heading-logo"
          />
          {t('pre-event-check')}
        </Heading>
        <Card data-testid="precall-page-card">
          <SlicesProvider reactiveMap={reactiveMap}>
            <SliceMount version="latest" />
          </SlicesProvider>
        </Card>
      </Wrapper>
    </ThemeProvider>
  );
};
